"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("../../../../../shared/components/MarkdownRenderers/MarkdownLinkRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BasicTemplate = function BasicTemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      title = _ref.title,
      subtitle = _ref.subtitle,
      image = _ref.image,
      linkTo = _ref.linkTo,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "responsive-hero__wrapper",
    style: {
      backgroundImage: "url('".concat(image.url, "')")
    }
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: "responsive-hero__title"
  }, dataClient.textToMarkdown(title)), /*#__PURE__*/_react["default"].createElement("p", {
    className: "responsive-hero__subtitle"
  }, dataClient.textToMarkdown(subtitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "responsive-hero__button-row"
  }, /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], {
    className: "responsive-hero__button",
    href: linkTo.url,
    external: linkTo.target === '_blank'
  }, dataClient.textToMarkdown(buttonText))));
};

BasicTemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  subtitle: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  image: _propTypes["default"].shape({}).isRequired,
  linkTo: _propTypes["default"].shape({}).isRequired,
  buttonText: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = BasicTemplate;
exports["default"] = _default;